import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Country, State, City } from "country-state-city";


const BASE_API_URL = process.env.REACT_APP_API_URL;

const API_URL = `${BASE_API_URL}/ContactUs`;
const API_URL_VOLUNTEER = `${BASE_API_URL}/Volunteer`;
const API_URL_ENROLMENT = `${ BASE_API_URL}/EnrollService`;


const EnrollForm = ({ className, showVolunteer, showVolunteerEvent, showMessage, showSubject, showBloodGroup, eventId }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [pincodes, setPincodes] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");

    // Load countries
    useEffect(() => {
        const allCountries = Country.getAllCountries();
        setCountries(allCountries);
    }, []);

    // Load states when country changes
    useEffect(() => {
        if (selectedCountry) {
            const allStates = State.getStatesOfCountry(selectedCountry);
            setStates(allStates);
        }
    }, [selectedCountry]);

    // Load cities when state changes
    useEffect(() => {
        if (selectedState) {
            const allCities = City.getCitiesOfState(selectedCountry, selectedState);
            setCities(allCities);
        }
    }, [selectedState, selectedCountry]);

     const [formData, setFormData] = useState({
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          subject: '',
          bloodGroup: '',
          interestedIn: [],
          message: '',
          address: '',
          gender: '',
     });

     const [errors, setErrors] = useState({
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          subject: '',
          bloodGroup: '',
          interestedIn: '',
          message: '',
          address: '',
          gender: '',
     });

     const [submitted, setSubmitted] = useState(false);
    const [acceptedTermsError, setAcceptedTermsError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false); // State for accepting terms and conditions

    const servicesData = JSON.parse(sessionStorage.getItem("manamvanam_services"));

     const validateInput = (name, value) => {
          const errorMessages = {
               firstName: 'First name is required and should only contain characters with no symbols or spaces.',
               lastName: 'Last name should only contain characters with no symbols or spaces.',
               phoneNumber: 'Phone number should only contain numbers, spaces, and "+" with a maximum of 15 digits.',
               email: 'Invalid email address.',
               subject: 'Subject is required.',
               bloodGroup: 'Blood Group is required.',
               interestedIn: 'Interested In is required.',
               message: 'Message is required.',
               address: 'Address is required.',
                gender: 'Gender is required.'
          };

          switch (name) {
               case 'firstName':
                    if (!value.trim()) {
                         return errorMessages.firstName;
                    }
                    if (!/^[a-zA-Z]+$/.test(value)) {
                         return errorMessages.firstName;
                    }
                    break;
               case 'lastName':
                    if (value && !/^[a-zA-Z]+$/.test(value)) {
                         return errorMessages.lastName;
                    }
                    break;
               case 'phoneNumber':
                    if (!value.trim()) {
                         return errorMessages.phoneNumber;
                    }
                    if (!/^[\d+ ]{0,15}$/.test(value)) {
                         return errorMessages.phoneNumber;
                    }
                    break;
               case 'email':
                    if (!/\S+@\S+\.\S+/.test(value)) {
                         return errorMessages.email;
                    }
                    break;
               case 'subject':
                  if (!value.trim() && (!showVolunteer && !showVolunteerEvent)) {
                         return errorMessages.subject;
                    }
                    break;
               case 'bloodGroup':
                  if (!value.trim() && (showVolunteer && showVolunteerEvent)) {
                         return errorMessages.bloodGroup;
                    }
                    break;
                case 'gender':
                  if (!value.trim() && (showVolunteer && showVolunteerEvent)) {
                         return errorMessages.gender;
                    }
                    break;
               case 'interestedIn':
                    if (value.length === 0) {
                         return errorMessages.interestedIn;
                    }
                    break;
               case 'message':
                  if (!value.trim() && (!showVolunteer && !showVolunteerEvent)) {
                         return errorMessages.message;
                    }
                    break;
               case 'address':
                  if (!value.trim() && showVolunteer) {
                         return errorMessages.address;
                    }
                    break;
               default:
                    break;
          }
          return '';
     };

     const handleChange = (e) => {
          const { name, value, type, checked } = e.target;
          const newValue = type === 'checkbox' ? formData.interestedIn.includes(value)
               ? formData.interestedIn.filter((item) => item !== value)
               : [...formData.interestedIn, value]
               : value;

          const errorMessage = validateInput(name, newValue);

          setErrors({ ...errors, [name]: errorMessage });
          setFormData({ ...formData, [name]: newValue });
     };

     const handleSubmit = (e) => {
          e.preventDefault();

          // Validate all form fields on submit
          const newErrors = {};
          Object.keys(formData).forEach((fieldName) => {
               const errorMessage = validateInput(fieldName, formData[fieldName]);
               newErrors[fieldName] = errorMessage;
          });

          setErrors(newErrors);

          // Check if there are any errors in the form
         var formHasErrors = Object.values(newErrors).some((error) => error !== '');

         if ((showVolunteer || showVolunteerEvent) && !acceptedTerms) {
             setAcceptedTermsError('Please accept the Terms and Conditions');
             formHasErrors = true;
         } else {
             setAcceptedTermsError('');
         }

          if (!formHasErrors) {
               // Perform form submission logic here (e.g., send data to the server)
              let apiurl = API_URL;
              if (showVolunteerEvent)
                  apiurl = API_URL_ENROLMENT;
              else if (showVolunteer)
                  apiurl = API_URL_VOLUNTEER;

              axios.post(`${apiurl}`, {
                  "firstName": formData.firstName,
                  "lastName": formData.lastName,
                  "emailAddress": formData.email,
                  "mobileNo": formData.phoneNumber,
                  "subject": formData.subject,
                  "bloodGroup": formData.bloodGroup,
                  "message": formData.message,
                  "address": formData.address,
                  "eventId": eventId,
                  "interestedServices": formData.interestedIn,
                  "gender": formData.gender,
                  "city": selectedCity,
                  "state": selectedState,
                  "country": selectedCountry,
                  "postalCode":""
              }).then(response => {
                  console.log(response);
                  setSubmitted(true);
                  // Reset the form after submission
                  setFormData({
                      firstName: '',
                      lastName: '',
                      phoneNumber: '',
                      email: '',
                      subject: '',
                      bloodGroup: '',
                      interestedIn: [],
                      message: '',
                      address: '',
                      gender: '',
                  });
                  // Clear any previous errors
                  setErrors({
                      firstName: '',
                      lastName: '',
                      phoneNumber: '',
                      email: '',
                      subject: '',
                      bloodGroup: '',
                      interestedIn: '',
                      message: '',
                      address: '',
                      gender: '',
                  });
              })
                    .catch(error => {
                         // Simulating form submission delay with setTimeout (replace this with actual API call)
                         setTimeout(() => {
                              setSubmitted(true);

                              // Reset the form after submission
                              setFormData({
                                   firstName: '',
                                   lastName: '',
                                   phoneNumber: '',
                                   email: '',
                                   subject: '',
                                   bloodGroup: '',
                                   interestedIn: [],
                                   message: '',
                                   address: '',
                                   gender: '',
                              });
                              // Clear any previous errors
                              setErrors({
                                   firstName: '',
                                   lastName: '',
                                   phoneNumber: '',
                                   email: '',
                                   subject: '',
                                   bloodGroup: '',
                                   interestedIn: '',
                                   message: '',
                                   address: '',
                                   gender: '',
                              });
                         }, 100); // Change the delay to your desired value
                    });
          }
     };

     return (
          <div>
               <form onSubmit={handleSubmit}>
                    <div className="row">
                         <div className={className}>
                              <div className="form-group text-left">
                                   <input
                                        type="text"
                                        className={`form-control mb-0 ${errors.firstName ? 'is-invalid' : ''}`}
                                        id="firstName"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        placeholder="First name"
                                   />
                                   {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                              </div>
                         </div>
                         <div className={className}>
                              <div className="form-group text-left">
                                   <input
                                        type="text"
                                        className={`form-control mb-0 ${errors.lastName ? 'is-invalid' : ''}`}
                                        id="lastName"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        placeholder="Last name"
                                   />
                                   {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                              </div>
                         </div>
                    </div>
                    <div className="row">
                         <div className={className}>
                              <div className="form-group text-left">
                                   <input
                                        type="text"
                                        className={`form-control mb-0 ${errors.phoneNumber ? 'is-invalid' : ''}`}
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        placeholder="Phone number"
                                   />
                                   {errors.phoneNumber && <div className="invalid-feedback">{errors.phoneNumber}</div>}
                              </div>
                         </div>
                         <div className={className}>
                              <div className="form-group text-left">
                                   <input
                                        type="email"
                                        className={`form-control mb-0 ${errors.email ? 'is-invalid' : ''}`}
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email"
                                   />
                                   {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                              </div>
                         </div>
                    </div>
                    <div className="row">
                         {showSubject && (
                              <div className={className}>
                                   <div className="form-group text-left">
                                        <input
                                             type="text"
                                             className={`form-control mb-0 ${errors.subject ? 'is-invalid' : ''}`}
                                             id="subject"
                                             name="subject"
                                             value={formData.subject}
                                             onChange={handleChange}
                                             placeholder="Subject"
                                        />
                                        {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
                                   </div>
                              </div>
                         )}
                         {showBloodGroup && (
                              <div className={className}>
                                   <div className="form-group text-left">
                                        <input
                                             type="text"
                                             className={`form-control mb-0 ${errors.bloodGroup ? 'is-invalid' : ''}`}
                                             id="bloodGroup"
                                             name="bloodGroup"
                                             value={formData.bloodGroup}
                                             onChange={handleChange}
                                             placeholder="Blood Group"
                                        />
                                        {errors.bloodGroup && <div className="invalid-feedback">{errors.bloodGroup}</div>}
                                   </div>
                              </div>
                         )}
                         <div className={className}><div className="form-group text-left">
                              <div
                                   className={`dropdown ${errors.interestedIn ? 'is-invalid' : ''}`}
                                   style={{ position: 'relative' }}
                              >
                                   <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        id="interestedInDropdown"
                                        data-bs-toggle="dropdown" // Use data-bs-toggle for Bootstrap 5
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                   >
                                        {formData.interestedIn.length === 0
                                             ? 'Select Your Interest'
                                             : formData.interestedIn.join(', ')}
                                   </button>
                                   <ul
                                        className="dropdown-menu p-3"
                                        aria-labelledby="interestedInDropdown"
                                        style={{ minWidth: '250px' }}
                                   >
                                        <li>
                                             <label className="dropdown-item">
                                                  <input
                                                       type="checkbox"
                                                       name="interestedIn"
                                                       value="All"
                                                       checked={formData.interestedIn.includes('All')}
                                                       onChange={handleChange}
                                                  />{' '}
                                                  All
                                             </label>
                                 </li>
                                 {servicesData.map((service) => (
                                     <li>
                                         <label className="dropdown-item">
                                             <input
                                                 type="checkbox"
                                                 name="interestedIn"
                                                 value={service.service_title}
                                                 checked={formData.interestedIn.includes(service.service_title)}
                                                 onChange={handleChange}
                                             />{' '}
                                             {service.service_title}
                                         </label>
                                     </li>
                                 ))}
                                        {/*<li>*/}
                                        {/*     <label className="dropdown-item">*/}
                                        {/*          <input*/}
                                        {/*               type="checkbox"*/}
                                        {/*               name="interestedIn"*/}
                                        {/*               value="RythuBandham"*/}
                                        {/*               checked={formData.interestedIn.includes('RythuBandham')}*/}
                                        {/*               onChange={handleChange}*/}
                                        {/*          />{' '}*/}
                                        {/*          Rythu Bandham*/}
                                        {/*     </label>*/}
                                        {/*</li>*/}
                                        {/*<li>*/}
                                        {/*     <label className="dropdown-item">*/}
                                        {/*          <input*/}
                                        {/*               type="checkbox"*/}
                                        {/*               name="interestedIn"*/}
                                        {/*               value="GirijanaBandham"*/}
                                        {/*               checked={formData.interestedIn.includes('GirijanaBandham')}*/}
                                        {/*               onChange={handleChange}*/}
                                        {/*          />{' '}*/}
                                        {/*          Girijana Bandham*/}
                                        {/*     </label>*/}
                                        {/*</li>*/}
                                        {/*<li>*/}
                                        {/*     <label className="dropdown-item">*/}
                                        {/*          <input*/}
                                        {/*               type="checkbox"*/}
                                        {/*               name="interestedIn"*/}
                                        {/*               value="GramaBandham"*/}
                                        {/*               checked={formData.interestedIn.includes('GramaBandham')}*/}
                                        {/*               onChange={handleChange}*/}
                                        {/*          />{' '}*/}
                                        {/*          Grama Bandham*/}
                                        {/*     </label>*/}
                                        {/*</li>*/}
                                        {/*<li>*/}
                                        {/*     <label className="dropdown-item">*/}
                                        {/*          <input*/}
                                        {/*               type="checkbox"*/}
                                        {/*               name="interestedIn"*/}
                                        {/*               value="JanahitaBandham"*/}
                                        {/*               checked={formData.interestedIn.includes('JanahitaBandham')}*/}
                                        {/*               onChange={handleChange}*/}
                                        {/*          />{' '}*/}
                                        {/*          Janahita Bandham*/}
                                        {/*     </label>*/}
                                        {/*</li>*/}
                                        {/*<li>*/}
                                        {/*     <label className="dropdown-item">*/}
                                        {/*          <input*/}
                                        {/*               type="checkbox"*/}
                                        {/*               name="interestedIn"*/}
                                        {/*               value="ParyavaranamBandham"*/}
                                        {/*               checked={formData.interestedIn.includes('ParyavaranamBandham')}*/}
                                        {/*               onChange={handleChange}*/}
                                        {/*          />{' '}*/}
                                        {/*          Paryavaranam Bandham*/}
                                        {/*     </label>*/}
                                        {/*</li>*/}
                                   </ul>
                              </div>
                              {errors.interestedIn && <div className="invalid-feedback">{errors.interestedIn}</div>}
                         </div></div>
                    </div>
                    {showMessage && (
                         <div className="row">
                              <div className="col-12">
                                    <div className="form-group text-left new-tf">
                                        <textarea
                                             className={`form-control mb-0 ${errors.message ? 'is-invalid' : ''}`}
                                             id="message"
                                             name="message"
                                             value={formData.message}
                                             onChange={handleChange}
                                             placeholder="Message"
                                        />
                                        {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                   </div>
                              </div>
                         </div>
                    )}
                    {showVolunteer && (
                         <>
                         <div className="row">
                             <div className="col-12">
                                 <div className="form-group text-center">
                                     <div className="d-flex justify-content-left">
                                         <label className="mr-30 pt-10">Gender : </label>
                                         {/* Male Radio Button */}
                                         <label className="mr-20 pt-10">
                                             <input
                                                 type="radio"
                                                 name="gender"
                                                 value="male"
                                                 checked={formData.gender === 'male'}
                                                 onChange={handleChange}
                                                // style={{ display: 'none' }} // Hide the actual radio button
                                             />
                                             {/*<img*/}
                                             {/*    src={male} // Replace with the actual path to the male image*/}
                                             {/*    alt="Male"*/}
                                             {/*    style={{*/}
                                             {/*        width: '25px',*/}
                                             {/*        marginRight: "5px",*/}
                                             {/*        cursor: 'pointer',*/}
                                             {/*        filter: formData.gender === 'male' ? 'brightness(0) saturate(100%) invert(58%) sepia(74%) saturate(413%) hue-rotate(42deg) brightness(96%) contrast(84%)' : 'none',*/}
                                             {/*    }}*/}
                                             {/*    onClick={() => handleChange({ target: { name: 'gender', value: 'male' } })}*/}
                                             {/*/>*/}
                                             <span> Male</span>
                                         </label>

                                         {/* Female Radio Button */}
                                         <label className="mr-20 pt-10">
                                             <input
                                                 type="radio"
                                                 name="gender"
                                                 value="female"
                                                 checked={formData.gender === 'female'}
                                                 onChange={handleChange}
                                                // style={{ display: 'none' }} // Hide the actual radio button
                                             />
                                             {/*<img*/}
                                             {/*    src={female}  // Replace with the actual path to the female image*/}
                                             {/*    alt="Female"*/}
                                             {/*    style={{*/}
                                             {/*        width: '25px',*/}
                                             {/*        marginRight: "5px",*/}
                                             {/*        cursor: 'pointer',*/}
                                             {/*        filter: formData.gender === 'female' ? 'brightness(0) saturate(100%) invert(58%) sepia(74%) saturate(413%) hue-rotate(42deg) brightness(96%) contrast(84%)' : 'none',*/}
                                             {/*    }}*/}
                                             {/*    onClick={() => handleChange({ target: { name: 'gender', value: 'female' } })}*/}
                                             {/*/>*/}
                                             <span> Female</span>
                                         </label>

                                         {/* Other Radio Button */}
                                         <label className="mr-20 pt-10">
                                             <input
                                                 type="radio"
                                                 name="gender"
                                                 value="other"
                                                 checked={formData.gender === 'other'}
                                                 onChange={handleChange}
                                                 //style={{ display: 'none' }} // Hide the actual radio button
                                             />
                                             {/*<img*/}
                                             {/*    src={others}  // Replace with the actual path to the other image*/}
                                             {/*    alt="Other"*/}
                                             {/*    style={{*/}
                                             {/*        width: '25px',*/}
                                             {/*        marginRight: "5px",*/}
                                             {/*        cursor: 'pointer',*/}
                                             {/*        filter: formData.gender === 'other' ? 'brightness(0) saturate(100%) invert(58%) sepia(74%) saturate(413%) hue-rotate(42deg) brightness(96%) contrast(84%)' : 'none',*/}
                                             {/*    }}*/}
                                             {/*    onClick={() => handleChange({ target: { name: 'gender', value: 'other' } })}*/}
                                             {/*/>*/}
                                             <span> Other</span>
                                         </label>
                                     </div>
                                     {errors.gender && <div className="invalid-feedback d-block text-left">{errors.gender}</div>}
                                 </div>
                             </div>
                             
                         </div>
                          <div className="row">
                               <div className="col-12">
                                   <div className="form-group text-left">
                                        <textarea
                                             className={`form-control mb-0 ${errors.address ? 'is-invalid' : ''}`}
                                             id="address"
                                             name="address"
                                             value={formData.address}
                                             onChange={handleChange}
                                             placeholder="Address"
                                        />
                                        {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                                   </div>
                              </div>
                         </div>
                              <div className="row">
                                   <div className="col-6">
                                 <div className="form-group text-left">
                                     {/*<input*/}
                                     {/*     type="text"*/}
                                     {/*     className="form-control mb-0"*/}
                                     {/*     id="country"*/}
                                     {/*     name="country"*/}
                                     {/*     onChange={handleChange}*/}
                                     {/*     placeholder="Country"*/}
                                     {/*/>*/}
                                     <select className="form-control mb-0" onChange={(e) => setSelectedCountry(e.target.value)}>
                                         <option>Select Country</option>
                                         {countries.map((country) => (
                                             <option key={country.isoCode} value={country.isoCode}>
                                                 {country.name}
                                             </option>
                                         ))}
                                     </select>
                                        </div>
                                   </div>
                                   <div className="col-6">
                                        <div className="form-group text-left">
                                             {/*<input*/}
                                             {/*     type="text"*/}
                                             {/*     className="form-control mb-0"*/}
                                             {/*     id="state"*/}
                                             {/*     name="state"*/}
                                             {/*     onChange={handleChange}*/}
                                             {/*     placeholder="State"*/}
                                     {/*/>*/}
                                     <select className="form-control mb-0"  onChange={(e) => setSelectedState(e.target.value)}>
                                         <option>Select State</option>
                                         {states.map((state) => (
                                             <option key={state.isoCode} value={state.isoCode}>
                                                 {state.name}
                                             </option>
                                         ))}
                                     </select>
                                        </div>
                                   </div>
                              </div>
                              <div className="row">
                                   <div className="col-6">
                                        <div className="form-group text-left">

                                     {/*<input*/}
                                     {/*     type="text"*/}
                                     {/*     className="form-control mb-0"*/}
                                     {/*     id="city"*/}
                                     {/*     name="city"*/}
                                     {/*     onChange={handleChange}*/}
                                     {/*     placeholder="City"*/}
                                     {/*/>*/}
                                     <select className="form-control mb-0" id="city" name="city" onChange={(e) => setSelectedCity(e.target.value)}>
                                         <option>Select City</option>
                                         {cities.map((city) => (
                                             <option key={city.name}>{city.name}</option>
                                         ))}
                                     </select>
                                        </div>
                                   </div>
                                   <div className="col-6">
                                        <div className="form-group text-left">
                                             <input
                                                  type="text"
                                                  className="form-control mb-0"
                                                  id="zipcode"
                                                  name="zipcode"
                                                  onChange={handleChange}
                                                  placeholder="Zipcode"
                                             />
                                        </div>
                                   </div>
                              </div>
                         </>
                    )}
                    {showVolunteerEvent && (
                         <div className='row'>
                              <div className='col-12'>
                                   <div className='form-group text-left'>
                                        <div className="d-flex" style={{ alignItems: 'baseline' }}>
                                             <input
                                                  type="checkbox"
                                                  className="mr-5"
                                             />
                                             <label>Become Volunteer for the event</label>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    )}
                 <div className="row">
                     {(showVolunteer || showVolunteerEvent) && (
                         <>
                             <div className="input-group mb-10 jc-sb">
                                 <div className="d-block">
                                     <div className="d-flex" style={{ alignItems: 'baseline' }}>
                                         <input
                                             type="checkbox"
                                             className="mr-5"
                                             checked={acceptedTerms}
                                             onChange={() => setAcceptedTerms(!acceptedTerms)}
                                         />
                                         <label>Accept Our <Link target="_blank" to="/terms-and-condition" className="green">Terms and Conditions</Link> & <Link target="_blank" to="/privacy-policy" className="green">
                                             Privacy Policy
                                         </Link></label>
                                     </div>
                                     {acceptedTermsError && (
                                         <p className="text-danger mb-0">{acceptedTermsError}</p>
                                     )}
                                 </div>
                             </div>
                         </>
                     )}
                         <div className="col text-right">
                              <button type="submit" className="btn btn-primary">
                                   Submit
                              </button>
                         </div>
                    </div>













               </form>

               {/* Popup to show after form submission */}
               {submitted && (
                    <div className="modal d-block">
                         <div className="modal-dialog">
                              <div className="modal-content">
                                   <div className="modal-header">
                                        <h5 className="modal-title">Form Submitted!</h5>
                                        <button
                                             type="button"
                                             className="close"
                                             onClick={() => setSubmitted(false)}
                                        >
                                             &times;
                                        </button>
                                   </div>
                                   <div className="modal-body">
                                        <p>Thank you for registering with us. Our team will get back to you soon.</p>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}
          </div>
     );
};

export default EnrollForm;
